import React from "react";

const popularCars = [
  {
    name: "Maruti Swift Dzire",
    image: "/images/gallery/maruti.jpg",
    description:
      "The Maruti Suzuki Dzire is a compact sedan perfect for city commutes and short intercity trips. With seating for 4 passengers and excellent mileage, it’s an affordable and reliable option for comfortable urban travel.",
    doors: "4 Doors",
    suitcase: "1 Large, 2 Small",
    passengers: "04",
  },

  {
    name: "Hyundai Aura",
    image: "/images/gallery/aura.jpg",
    description:
      "The Hyundai Aura is a compact sedan that blends premium comfort with performance. Its refined interiors, modern styling, and superior ride quality make it ideal for business travel and urban commuting.",
    doors: "4 Doors",
    suitcase: "1 Large, 2 Small",
    passengers: "04",
  },

  {
    name: "Honda Amaze",
    image: "/images/gallery/amaze.jpg",
    description:
      "The Honda Amaze offers a sophisticated travel experience with its spacious cabin, responsive engine, and elegant design. Perfect for executives and families who value both comfort and style on every drive.",
    doors: "4 Doors",
    suitcase: "2 Large, 2 Small",
    passengers: "04",
  },

  {
    name: "Maruti Suzuki Ertiga",
    image: "/images/gallery/ertiga.jpg",
    description:
      "The Maruti Suzuki Ertiga is a stylish 7-seater MPV offering the perfect mix of comfort, space, and efficiency. Ideal for family outings, long-distance rides, or group travel, it ensures a smooth and enjoyable journey every time.",
    doors: "4 Doors",
    suitcase: "2 Large, 2 Small",
    passengers: "07",
  },

  {
    name: "Toyota Rumion",
    image: "/images/gallery/Rumion.jpg",
    description:
      "The Toyota Rumion is a stylish and fuel-efficient MPV designed for comfortable family travel and daily commuting. With its spacious cabin, smooth performance, and reliable build quality, it’s an excellent choice for city rides, outstation trips, and corporate travel.",
    doors: "4 Doors",
    suitcase: "2 Large, 1 Small",
    passengers: "07",
  },

  {
    name: "Toyota Innova Crysta",
    image: "/images/gallery/crysta.jpg",
    description:
      "The Toyota Innova Crysta sets the benchmark for luxury MPVs with its powerful engine, plush interiors, and class-leading comfort. It’s the preferred vehicle for family vacations, long-distance tours, and corporate rides.",
    doors: "4 Doors",
    suitcase: "2 Large, 2 Small",
    passengers: "07",
  },

  {
    name: "Toyota Innova Hycross",
    image: "/images/gallery/hycross.jpg",
    description:
      "The Toyota Innova Hycross is a premium hybrid MPV offering exceptional mileage, luxurious interiors, and advanced technology. Perfect for corporate travel, long-distance journeys, and family trips with top-tier comfort and spacious seating.",
    doors: "4 Doors",
    suitcase: "2 Large, 2 Small",
    passengers: "07",
  },

  {
    name: "Toyota Fortuner",
    image: "/images/gallery/fortuner.jpg",
    description:
      "The Toyota Fortuner is a powerful full-size SUV built for unmatched road presence, superior comfort, and reliable performance. Ideal for luxury corporate travel and long-distance premium trips.",
    doors: "4 Doors",
    suitcase: "3 Large, 2 Small",
    passengers: "07",
  },

 {
  name: "Mercedes-Benz E220",
  image: "/images/gallery/e220.jpg",
  description:
    "The Mercedes-Benz E220 offers a superior luxury experience with advanced features, plush interiors, and an exceptionally smooth ride. It is the perfect choice for VIP guests, corporate executives, and premium business travel.",
  doors: "4 Doors",
  suitcase: "2 Large, 2 Small",
  passengers: "04",
},

  {
    name: "Mercedes-Benz E250",
    image: "/images/gallery/e250.jpg",
    description:
      "The Mercedes-Benz E250 delivers an elite travel experience with advanced technology, plush seating, and exceptional performance. Ideal for VIP clients and premium corporate transfers.",
    doors: "4 Doors",
    suitcase: "2 Large, 2 Small",
    passengers: "04",
  },

  {
    name: "Jaguar XF",
    image: "/images/gallery/jaguar-xf.jpg",
    description:
      "The Jaguar XF is a luxury sedan known for its dynamic performance, elegant design, and superior comfort. Perfect for executives who prefer a refined and stylish travel experience.",
    doors: "4 Doors",
    suitcase: "2 Large, 1 Small",
    passengers: "04",
  },

  {
    name: "BMW 5 Series",
    image: "/images/gallery/bmw-5series.jpg",
    description:
      "The BMW 5 Series is a premium executive sedan offering a blend of luxury, powerful performance, and cutting-edge features. Ideal for high-class corporate and airport travel.",
    doors: "4 Doors",
    suitcase: "2 Large, 2 Small",
    passengers: "04",
  },

  {
    name: "BMW 3 Series",
    image: "/images/gallery/bmw-3series.jpg",
    description:
      "The BMW 3 Series delivers sporty performance with luxury comfort, making it a top choice for business travelers seeking elegance and agility on every journey.",
    doors: "4 Doors",
    suitcase: "1 Large, 2 Small",
    passengers: "04",
  },

  {
    name: "Toyota Camry",
    image: "/images/gallery/camry.jpg",
    description:
      "The Toyota Camry is a premium hybrid sedan offering exceptional comfort, refined interiors, and a smooth driving experience. A popular choice for luxury corporate travel.",
    doors: "4 Doors",
    suitcase: "2 Large, 1 Small",
    passengers: "04",
  },

  {
    name: "Kia Carnival",
    image: "/images/gallery/carnival.jpg",
    description:
      "The Kia Carnival is a premium MPV offering unmatched space, luxury seating, and superior comfort. Perfect for group corporate travel, airport transfers, and long-distance premium journeys.",
    doors: "4 Doors",
    suitcase: "4 Large, 2 Small",
    passengers: "07",
  },
];


const PopularCarsSection = () => {
  return (
    <section className="popular-car-section grey-bg">
      <div className="container">
        
        {/* Section Title */}
        <div className="section-title centred mb_60">
          <span className="sub-title">Pune Corporate Cars India Private Limited</span>
          <h2 className="title">Most Popular Cars For Corporate</h2>
        </div>

        {/* Cars Grid */}
        <div className="row">
          {popularCars.map((car, index) => (
            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12" key={index}>
              <div className="single-popular-car-block Popular">

                {/* Car Image */}
                <div className="single-popular-car-image">
                  <img src={car.image} alt={car.name} />
                </div>

                {/* Content */}
                <div className="single-popular-car-content">

                  <h5 className="single-popular-car-title">{car.name}</h5>
                  <p className="single-popular-car-text">{car.description}</p>

                  <div className="border-divider"></div>

                  <ul className="single-popular-car-info">
                    <li>
                      <i className="icon-6"></i>Doors: {car.doors}
                    </li>
                    <li>
                      <i className="icon-7"></i>Suitcase: {car.suitcase}
                    </li>
                    <li>
                      <i className="icon-8"></i>Passengers: {car.passengers}
                    </li>
                  </ul>

                  {/* WhatsApp Book Now Button */}
                  <div className="single-popular-car-book-btn">
                    {/* <a
                      href={`https://wa.me/919822136667?text=${encodeURIComponent(
                        `Hello, I want to book the ${car.name}.`
                      )}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn-style-three"
                    >
                      Book now
                    </a> */}

                       <a
                      href= "/book"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn-style-three"
                    >
                      Book now
                    </a>
                  </div>

                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default PopularCarsSection;
